import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import _ from 'lodash'

import { certificatesReselector as stateSelector } from 'reduxModules/certificates/selectors'
import { certificatesDispatchers as dispatchSelector } from 'reduxModules/certificates/dispatchers'
import { types } from 'reduxModules/certificates'

import Certificate from './Certificate'
import ClaimModal from './ClaimModal'
import './styles.css'

export function Certificates({
  certificates = null,
  defaultName = '',
  isMobile = false,
  ...props
}) {
  const [claiming, setClaiming] = useState(null)
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    props.loadCertificates()
  }, [])

  // The course-completion email links to /certificates?course=<slug>; once the
  // list arrives, open the claim modal for that course if it's unclaimed.
  useEffect(() => {
    const slug = searchParams.get('course')
    if (!slug || !certificates) return
    const certificate = _.find(certificates, (c) => c.tutorial.slug === slug)
    if (certificate && !certificate.isClaimed) setClaiming(certificate)
    const cleaned = new URLSearchParams(searchParams)
    cleaned.delete('course')
    setSearchParams(cleaned, { replace: true })
  }, [certificates])

  const onSubmitClaim = ({ name }) =>
    props.claimCertificate(claiming.tutorial.slug, name).then((res) => {
      if (res.type === types.CERTIFICATE_CLAIM_SUCCESS) setClaiming(null)
    })

  if (!certificates) return null
  return (
    <div id="Certificates" className="account-section">
      <h3 className="account-section__title">My Certificates</h3>
      {!_.isEmpty(certificates) && (
        <div className="certificates-list">
          {certificates.map((certificate) => (
            <Certificate
              key={certificate.tutorial.slug}
              certificate={certificate}
              onClaim={() => setClaiming(certificate)}
            />
          ))}
        </div>
      )}
      {_.isEmpty(certificates) && (
        <div className="no-results">
          <svg
            className="no-results__icon"
            viewBox="0 0 24 24"
            width="56"
            height="56"
            aria-hidden="true"
          >
            <path
              fill="currentColor"
              d="M12 2 3 6v6c0 5 3.8 8.6 9 10 5.2-1.4 9-5 9-10V6l-9-4Zm-1.3 13.3L7.4 12l1.4-1.4 1.9 1.9 4.1-4.1 1.4 1.4-5.5 5.5Z"
            />
          </svg>
          <span>
            You haven&apos;t completed any course yet. Finish watching a course
            and your Certificate of Completion will show up here.
          </span>
        </div>
      )}
      {claiming && (
        <ClaimModal
          certificate={claiming}
          defaultName={claiming.printedName || defaultName}
          isMobile={isMobile}
          onClose={() => setClaiming(null)}
          onSubmit={onSubmitClaim}
        />
      )}
    </div>
  )
}

Certificates.propTypes = {
  loadCertificates: PropTypes.func.isRequired,
  claimCertificate: PropTypes.func.isRequired,
  certificates: PropTypes.arrayOf(PropTypes.object),
  defaultName: PropTypes.string,
  isMobile: PropTypes.bool
}

export default connect(stateSelector, dispatchSelector)(Certificates)
